export function shouldMarkPromptAsOptionAnswer(
  messages: Array<{ from?: string; options?: unknown[]; suggestions?: unknown[] }> | null | undefined
): boolean {
  const lastMessage = messages?.[messages.length - 1];

  if (!lastMessage) {
    return false;
  }

  const isBotMessage = lastMessage.from === 'bot' || lastMessage.from === 'bot-like';
  const hasOptions = (lastMessage.options?.length ?? 0) > 0;
  const hasSuggestions = (lastMessage.suggestions?.length ?? 0) > 0;

  return isBotMessage && (hasOptions || hasSuggestions);
}